<template>
    <div>
      <slot></slot>
    </div>
</template>
<script type="text/babel">
  import Masonry from "masonry-layout"
  import Imagesloaded from "imagesloaded"
  import {mapState,mapActions} from 'vuex';


  /**
   * doc url :https://masonry.desandro.com/
   * doc.cn url :http://www.cnblogs.com/cjc917/p/7402026.html
   */
  export default {
    computed: {
      ...mapState({
        updateWaterfall: state => state.updateWaterfall
      }),
    },
    props:{
      containerClass:{
        type:String,
        default:'waterfall-container'
      },
      itemClass:{
        type:String,
        default:'waterfall-item'
      },
      columnWidth:{
        type:Number,
        default:360
      }
    },
    watch:{
      updateWaterfall(){
        if(this.updateWaterfall){
          this.init();
          this.commitWaterfallUpdate(false)
        }
      }
    },
    mounted(){
      this.$nextTick(function () {
        this.init();
      })
    },
    data(){
      return {}
    },
    methods: {
      ...mapActions([
        'commitWaterfallUpdate'
      ]),
      init(){
        let containerClass = `.${this.containerClass}`,
            itemClass = `.${this.itemClass}`,
            columnWidth = this.columnWidth;
        Imagesloaded(containerClass,()=>{
          new Masonry($(containerClass)[0],{
            itemSelector: itemClass,
            gutter: 20,
            columnWidth:columnWidth,
            horizontalOrder: true
          })
        })
      },
    }
  }
</script>
<style lang="less" scoped>

</style>
